// Intro overlay with small animations of the parts
import { Registry, CORE } from '../core/registry';
import { GFX } from '../core/graphics';
import { SFX } from '../core/audio';
import { $ } from './dom';
import { G } from './state';
import { setI } from './icons';
import type { Ctx2D, GameBody, IntroHelpers } from '../core/types';

// ---------- Small animations that show how a part works (no text) ----------
// The animation belongs to the part or object (def.intro in src/kit/ and the worlds).
export const hasIntro = (k: string) => !!Registry.intro(k);
let introKey = '', introT = 0;
export function openIntro(k: string) { introKey = k; introT = 0; $('#ovIntro').hidden = false; }
$('#introOk').addEventListener('click', () => { SFX.init(); SFX.play('click'); $('#ovIntro').hidden = true; });
$('#infoBtn').addEventListener('click', () => { SFX.play('click'); openIntro(G.level.intro!); });
// A stand-in ball for drawing: only the fields GFX.ball reads
export const fakeBall = (x: number, y: number, vx: number, vy: number, r?: number, painted?: boolean) =>
  ({ position: { x, y }, velocity: { x: vx, y: vy }, circleRadius: r || 18, painted, roll: x / (r || 18) }) as unknown as GameBody;
const ease = (k: number) => k < 0 ? 0 : k > 1 ? 1 : k * k * (3 - 2 * k);
export function drawIntro() {
  const c = $<HTMLCanvasElement>('#introCv'), x = c.getContext('2d')!;
  const t = (G.freeze ? G.t : introT++) % 240;
  x.setTransform(2, 0, 0, 2, 0, 0); x.clearRect(0, 0, 460, 280);
  x.fillStyle = 'rgba(255,255,255,.35)'; x.fillRect(0, 240, 460, 40);
  const idf = Registry.intro(introKey), h: IntroHelpers = { fakeBall, arrow: (ax, ay, bx, len, up) => arrow(x, ax, ay, bx, len, up), ease };
  // The kit's intros have always run without save/restore, so their drawing state (e.g. the paint's lineCap) carries
  // over to the next frames. Kept so the shots stay unchanged; can be cleaned up together with updated shots.
  const def = Registry.parts[introKey] || Registry.objs[introKey];
  if (idf && def && def.world === CORE) idf(x, t, GFX, h);
  else if (idf) { x.save(); idf(x, t, GFX, h); x.restore(); }
  // soft edge
  function arrow(x2: Ctx2D, ax: number, ay: number, _bx2: number, len: number, up?: boolean) {
    x2.save(); x2.strokeStyle = 'rgba(59,42,92,.5)'; x2.fillStyle = 'rgba(59,42,92,.5)'; x2.lineWidth = 6; x2.lineCap = 'round';
    const y0 = up ? ay + len / 2 : ay - len / 2, y1 = up ? ay - len / 2 : ay + len / 2;
    x2.beginPath(); x2.moveTo(ax, y0); x2.lineTo(ax, y1); x2.stroke();
    const d = up ? -1 : 1; x2.beginPath(); x2.moveTo(ax - 10, y1 - d * 8); x2.lineTo(ax, y1 + d * 6); x2.lineTo(ax + 10, y1 - d * 8); x2.fill();
    x2.restore();
  }
}
setI($('#introOk'), 'check');
